export default {"src":"/_next/static/media/youtube.f058511b.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};